define('charts/layers/series',["require", "exports", "../../util/math"], function (require, exports, math_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SeriesLayer = void 0;
    /**
     * Renders a list of ChartSeries lines
     */
    var SeriesLayer = /** @class */ (function () {
        function SeriesLayer(track, series) {
            this.lines = {};
            this.track = track;
            this.series = series;
        }
        SeriesLayer.prototype.init = function (chart) {
            // Add layer group
            this.svgGroup = chart.layers.space.append("g")
                .attr("class", "paths")
                .style("clip-path", "url(#chart-clipping-time)")
                .style("fill", "none")
                .style("stroke-width", 1);
            var _loop_1 = function (options) {
                this_1.lines[options.name] = d3.line()
                    .defined(function (d) { return (0, math_1.isReal)(options.localValue(d)); })
                    .x(function (d) { return chart.xAxis.scale(d.date); })
                    .y(function (d) { return chart.yAxis[options.axis].scale(options.localValue(d)); });
            };
            var this_1 = this;
            // Construct d3 lines
            for (var _i = 0, _a = this.series; _i < _a.length; _i++) {
                var options = _a[_i];
                _loop_1(options);
            }
        };
        SeriesLayer.prototype.update = function (chart) {
            var _this = this;
            // Update the plot lines
            var paths = this.svgGroup.selectAll("path")
                .data(this.seriesEnabled());
            paths.enter()
                .append("path")
                .merge(paths)
                .attr("class", function (d) { return d.name; })
                .attr("d", function (d) { return _this.lines[d.name](_this.track.data); })
                .style("stroke", function (d) { return d.color; });
            paths.exit().remove();
        };
        SeriesLayer.prototype.remove = function () {
            this.svgGroup.remove();
        };
        SeriesLayer.prototype.seriesEnabled = function () {
            return this.series.filter(function (options) { return options.enabled; });
        };
        return SeriesLayer;
    }());
    exports.SeriesLayer = SeriesLayer;
});
//# sourceMappingURL=/assets/javascripts/charts/layers/series.js.map;
